/**
 * The code in an invitation link (`…/creator-signup?code=<code>`) on any
 * domain, with or without its scheme, or null when the text isn't one.
 */
export function invitationLinkCode(text: string): string | null {
	const trimmed = text.trim();
	const url =
		parseURL(trimmed) ??
		(/^[^/:\s]+\.[^/\s]+\//.test(trimmed)
			? parseURL(`https://${trimmed}`)
			: null);
	if (url === null || url.pathname.replace(/\/+$/, "") !== "/creator-signup") {
		return null;
	}
	return url.searchParams.get("code")?.trim() || null;
}

function parseURL(text: string): URL | null {
	try {
		return new URL(text);
	} catch {
		return null;
	}
}
